import React from "react";
import ArrowButton from "../ArrowButton";

const ShowErrorModal = ({ msg, onConfirm, buttonClassName }) => {
  return (
    <div className="home_popup_container">
      <svg
        width="50"
        height="49"
        viewBox="0 0 50 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.9842 48.5214C23.6646 48.5214 22.4421 47.9259 21.6287 46.8858L16.7344 40.679L8.15511 40.6737C3.93446 40.6737 0.5 37.2393 0.5 33.0175V8.03905C0.5 3.81728 3.93446 0.382812 8.15623 0.382812H41.8437C46.0654 0.382812 49.4999 3.81728 49.4999 8.03905V23.4472C49.4999 24.5044 48.6431 25.3613 47.5858 25.3613C46.5286 25.3613 45.6718 24.5044 45.6718 23.4472V8.03905C45.6718 5.92835 43.9544 4.21093 41.8437 4.21093H8.15623C6.04554 4.21093 4.32812 5.92835 4.32812 8.03905V33.0175C4.32812 35.1282 6.04554 36.8456 8.15623 36.8456L17.6645 36.8512C18.2503 36.8516 18.8036 37.1204 19.1662 37.5802L24.6396 44.5213C24.7513 44.6645 24.8878 44.6933 24.9846 44.6933H24.9865C25.0829 44.6929 25.2205 44.6634 25.3274 44.5247C25.3308 44.5202 25.3342 44.5157 25.3375 44.5116L30.7664 37.5795C31.1294 37.1163 31.6849 36.8456 32.2734 36.8456H41.8437C43.9547 36.8456 45.6718 35.1282 45.6718 33.0175C45.6718 31.9603 46.5286 31.1035 47.5858 31.1035C48.6431 31.1035 49.4999 31.9603 49.4999 33.0175C49.4999 37.2393 46.0654 40.6737 41.8437 40.6737H33.2057L28.3555 46.8664C27.5465 47.9132 26.3248 48.5162 25.0014 48.5214C24.9958 48.5214 24.9899 48.5214 24.9842 48.5214ZM26.914 29.5722V19.2363C26.914 18.1791 26.0572 17.3222 25 17.3222C23.9427 17.3222 23.0859 18.1791 23.0859 19.2363V29.5722C23.0859 30.6294 23.9427 31.4863 25 31.4863C26.0572 31.4863 26.914 30.6294 26.914 29.5722ZM25 10.7187C23.9427 10.7187 23.0859 11.5756 23.0859 12.6328C23.0859 13.69 23.9427 14.5468 25 14.5468C26.0572 14.5468 26.914 13.69 26.914 12.6328C26.914 11.5756 26.0572 10.7187 25 10.7187Z"
          fill="#E12014"
        />
      </svg>
      <p className="home_popup_info_text">{msg}</p>
      <div className="home_page_popup_arrow_btn">
        <ArrowButton
          onClick={onConfirm}
          type={"next"}
          label={"Got it"}
          styleProp={{
            borderRadius: "15px",
          }}
          className={buttonClassName}
        />
      </div>
    </div>
  );
};

export default ShowErrorModal;
